// extracted by mini-css-extract-plugin
export default {"row-music-shelf-list":"RowMusicShelfList_row-music-shelf-list__HM15v"};